var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(_vm.authenticated)?_c('v-content',[_c('app-bar',{attrs:{"user":_vm.user,"logout":_vm.logout}}),_c('router-view',{attrs:{"keycloak":_vm.keycloak,"authenticated":_vm.authenticated}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }